/* eslint-disable */
import API from "../../helpers/API";
import { hideLoader, showLoader, getDigilockerLink, encryptData } from "../../common/actions/commonActions";
import {
  SET_REGISTRATION_RESPONSE,
  SET_SECURITY_QUESTIONS,
  SET_SECURITY_QUESTIONS_FORGOT_PASSWORD,
  SET_SECURITY_QUESTIONS_FOR_RESET_EMAIL,
  SET_SECURITY_QUESTIONS_FOR_LOGIN,
} from "../../common/constants/ActionTypes";
import {
  REGISTRATION,
  SECURITY_QUESTIONS,
  GET_DIGILOCKER_URL,
  CONFIGURATION
} from "../../common/constants/endpoints";
import { toastr } from "react-redux-toastr";
import commonLabels from "../../common/labels/common_en.json";
import loginLabels from "../labels/login_en.json"
import { legacy_apiUrl, legacy_secretKey } from "../Secrets/Legacy";
import axios from "axios";

export const getSecurityQuestions = () => {
  return async (dispatch) => {
    try {
      let response = await API.get(SECURITY_QUESTIONS);

      if (response && response.data) {
        dispatch({
          payload: response.data,
          type: SET_SECURITY_QUESTIONS,
        });
        dispatch({
          payload: response.data,
          type: SET_SECURITY_QUESTIONS_FORGOT_PASSWORD,
        });
        dispatch({
          payload: response.data,
          type: SET_SECURITY_QUESTIONS_FOR_RESET_EMAIL,
        });
        dispatch({
          payload: response.data,
          type: SET_SECURITY_QUESTIONS_FOR_LOGIN,
        });
      }
    } catch (error) {

      toastr.error(commonLabels.COMMON.SECURITY_QUE_ERROR, error.message);
    }
  };
};

export const registerCandidate = (newCandidateDetails, props, captchaId, emailOTPResponse, mobileOTPResponse, enteredEmailOtp, enteredMobileOtp, navigate, genderLabel, idTypeLabel, mobileNumber, userName) => {
  const logData = {
    newCandidateDetails,
    props,
    captchaId,
    emailOTPResponse,
    mobileOTPResponse,
    enteredEmailOtp,
    enteredMobileOtp,
    navigate,
    genderLabel,
    idTypeLabel,
    mobileNumber,
    userName
  };

  let name = newCandidateDetails.verifyCandidateName;
  let fatherName = newCandidateDetails.verifyCandidateFatherName;
  let motherName = newCandidateDetails.verifyCandidateMotherName;

  const trimmedName = name.trim();

  const nameArr = [name, fatherName, motherName];

  for (let i = 0; i < nameArr.length; i++) {
    if (nameArr[i].includes("*")) {
      toastr.warning("The character ( * ) is not allowed in Candidate name, Father name, or Mother name.");
      return;
    }
  }

  // Check for leading/trailing spaces
  if (name !== trimmedName) {
    alert("Please remove spaces from the beginning or end of the name, father name, mother name.");
    return;
  }
  // Check for double or more spaces between words
  if (/\s{2,}/.test(name)) {
    toastr.error("Please remove extra spaces between candidate name.");
    return;
  }
  if (/\s{2,}/.test(fatherName)) {
    toastr.error("Please remove extra spaces between candidate's father name.");
    return;
  }
  if (/\s{2,}/.test(motherName)) {
    toastr.error("Please remove extra spaces between candidate's mother name.");
    return;
  }


  return async (dispatch) => {
    dispatch(showLoader());
    try {
      let securityAnswersDto = {};
      let sq_keys = Object.keys(newCandidateDetails).filter((key) => {
        return key.includes("SQ");
      })
      sq_keys.map((sq_key) => {
        securityAnswersDto[sq_key] = newCandidateDetails[sq_key]
      })

      sessionStorage.setItem("userEmail", userName);
      sessionStorage.setItem("userHscYear", securityAnswersDto['SQ1']);
      sessionStorage.setItem("userHscBoard", securityAnswersDto['SQ2']);
      sessionStorage.setItem("userHscRollNo", securityAnswersDto['SQ3']);
      let candidateNameValue = newCandidateDetails.verifyCandidateName.toUpperCase();
      let candidateFatherNameValue = newCandidateDetails.verifyCandidateFatherName.toUpperCase();
      let candidateMotherNameValue = newCandidateDetails.verifyCandidateMotherName.toUpperCase();
      let request = {
        "candidateName": candidateNameValue.trim(),
        "candidateFatherName": candidateFatherNameValue.trim(),
        "candidateMotherName": candidateMotherNameValue.trim(),
        "email": userName,
        "password": newCandidateDetails.confirmPassword,
        "mobile": mobileNumber,
        "dob": newCandidateDetails.verifiedDob,
        "userType": "Candidate",
        "securityAnswersList": securityAnswersDto,
        "captchaId": captchaId,
        "enteredCaptcha": newCandidateDetails.enteredCaptcha,
        "emailOtpId": emailOTPResponse.id,
        "enteredEmailOtp": enteredEmailOtp,
        "mobileOtpId": mobileOTPResponse.id,
        "enteredMobileOtp": enteredMobileOtp,
        "otpFor": "register",
        "genderLookupId": newCandidateDetails.verifyGender,
        "genderLabel": genderLabel,
        "idTypeLookupId": newCandidateDetails.idTypeLookupId,
        "idTypeLabel": idTypeLabel,
        "idNumber": (idTypeLabel === commonLabels.COMMON.AADHAR_CARD ? newCandidateDetails.verifyAadharNo : idTypeLabel === commonLabels.COMMON.PAN_CARD ? newCandidateDetails.verifyPanNo.toUpperCase() : idTypeLabel === commonLabels.COMMON.DRIVING_LICENCE ? newCandidateDetails.verifyDrivingLicenceNo.toUpperCase() : '')
      }

      if (newCandidateDetails.verifiedDob) {
        var today = new Date();
        var nowyear = today.getFullYear();
        var nowmonth = today.getMonth();
        var nowday = today.getDate();
        var birth = new Date(newCandidateDetails.verifiedDob);
        var birthyear = birth.getFullYear();
        var birthmonth = birth.getMonth();
        var birthday = birth.getDate();
        var age = nowyear - birthyear;
        var age_month = nowmonth - birthmonth;
        var age_day = nowday - birthday;
        if (age_month < 0 || (age_month == 0 && age_day < 0)) {
          age = parseInt(age) - 1;
        }
        if ((age < 18 && age_month <= 0 && age_day <= 0) || age < 18) {
          dispatch(hideLoader());
          toastr.error(commonLabels.SIGN_UP.AGE_NOTE);
          return false;
        }
      }
      let password = newCandidateDetails.password;
      let confirmpassword = newCandidateDetails.confirmPassword;
      if (password !== confirmpassword) {
        toastr.error(commonLabels.SIGN_UP.NEW_PASS_AND_CONFIRM_PASS_NOTE);
      }
      else {
        let response = await API.post(REGISTRATION, request);
        if (response != null) {
          dispatch(hideLoader());
        }
        if (response) {
          //props.history.push("/candidate/login");
          //navigate("/candidate/login")

          toastr.success(commonLabels.COMMON.USER_REGISTER_SUCCESSFULLY_NOTE);
          dispatch({
            payload: true,
            type: SET_REGISTRATION_RESPONSE
          });
          if (response && response.data && response.data.digilocker) {
            toastr.confirm(commonLabels.COMMON.DIGILOCKER_CONFIRMATION_MES, {
              okText: "Yes",
              cancelText: "No",
              onOk: async () => {
                let digilockerResponse = await API.get(GET_DIGILOCKER_URL);
                if (digilockerResponse && digilockerResponse.data) {
                  window.location.href = digilockerResponse.data;
                } else {
                  navigate("/candidate/login");
                }
              },
              onCancel: async () => {
                navigate("/candidate/login");
              }
            })
          } else {
            navigate("/candidate/login");
          }
          // if (digilockerResponse && digilockerResponse.data) {
          //   navigate("/candidate/login");
          //   window.location.href = digilockerResponse.data;
          // } else {
          //   navigate("/candidate/login");
          // }
        }
      }
    } catch (error) {
      dispatch(hideLoader());
      if (error.response && error.response.data) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(commonLabels.COMMON.LOGIN_FAILED, error.message);
      }

    }
  };
};



export const legacyLoginFunction = async (username, password) => {



  let encryptedUnserName = encryptData(username);
  let encryptedPassword = encryptData(password);

  try {
    const result = await axios.post(
      legacy_apiUrl,
      {
        UserName: encryptedUnserName,
        Password: encryptedPassword,
      },
      {
        headers: {
          "Content-Type": "application/json",
          "X_API_Key": legacy_secretKey,
        },
      }
    );

    const redirectUrl = result.data;

    if (result.status === 200) {
      toastr.success(loginLabels.LOGIN_SUCCCESS_MESSAGE);
      return window.location.href = redirectUrl;
    } else {
      toastr.warning(loginLabels.LOGIN_FAILURE_MESSAGE);
    }

  } catch (error) {
    toastr.error(loginLabels.LOGIN_FAILURE_MESSAGE);
  }
};
